import { Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

export const routes: Routes = [
   {
      path: 'auth',
      component: AuthLayoutComponent,
      children: [
         {
            path: '',
            redirectTo: 'login',
            pathMatch: 'full',
         },
         {
            path: 'login',
            component: LoginComponent
         },
         { path: '', redirectTo: 'login', pathMatch: 'full' },
         { path: '**', redirectTo: 'login', pathMatch: 'full' },
      ],
   },
   {
      path: 'error',
      loadChildren: () => import('./features/errors/errors.module').then((m) => m.ErrorsModule),
   },
   {
      path: '',
      canActivate: [AuthGuard],
      loadChildren: () => import('./layouts/main-layout/main-layout.module').then((m) => m.MainLayoutModule),
   },
   { path: '**', redirectTo: 'error/404' },
];
